import React from 'react';
import PropTypes from 'prop-types';
import {
  ConnectFulfillmentProviderModalContextProvider,
  useConnectFulfillmentProviderContext,
} from '../../../../../components/modals/fulfillment-provider-registration-modal/context-provider';
import { ProviderTableHeader } from '../../components';
import { useProvidersGridContext } from '../../providers-grid-context';
import { trackFulfillmentProviderConnetionStart } from '../../tracking-events';
import messages from './messages';

const connectionEnabledMessages = {
  headerMessage: messages.fulfillmentServices,
  buttonMessage: messages.addAProvider,
};

const useMessages = () => {
  return connectionEnabledMessages;
};

const FulfillmentProviderHeader = (props) => {
  const { onConnectFulfillmentProvider } = useConnectFulfillmentProviderContext();

  const onBtnClick = () => {
    onConnectFulfillmentProvider();
    trackFulfillmentProviderConnetionStart('settings-fulfillment providers page');
  };

  const { headerMessage, buttonMessage } = useMessages();

  return <ProviderTableHeader buttonMessage={buttonMessage} headerMessage={headerMessage} onBtnClick={onBtnClick} {...props} />;
};

FulfillmentProviderHeader.propTypes = {
  showInactive: PropTypes.bool.isRequired,
  toggleInactive: PropTypes.func.isRequired,
};

const WithContext = ({ onError, onRegistrationFailure, showInactive, toggleInactive }) => {
  const { fulfillmentProviders } = useProvidersGridContext();

  return (
    <ConnectFulfillmentProviderModalContextProvider
      onError={onError}
      onRegisterSuccess={fulfillmentProviders.updateList}
      onRegistrationFailure={onRegistrationFailure}
    >
      <FulfillmentProviderHeader showInactive={showInactive} toggleInactive={toggleInactive} />
    </ConnectFulfillmentProviderModalContextProvider>
  );
};

WithContext.propTypes = {
  onError: PropTypes.func.isRequired,
  onRegistrationFailure: PropTypes.func.isRequired,
  showInactive: PropTypes.bool.isRequired,
  toggleInactive: PropTypes.func.isRequired,
};

export { WithContext as FulfillmentProviderHeader };
